import { QueryClientProvider } from '@tanstack/react-query';
import { useState, type JSX } from 'react';
import { RouterProvider } from 'react-router';

import { createQueryClient } from '@/app/queryClient';
import { router } from '@/app/router';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { ThemeProvider } from '@/theme/ThemeProvider';

export function AppProviders(): JSX.Element {
  // Created once per app instance rather than at module scope, so tests and
  // any future server rendering never share a cache between renders.
  const [queryClient] = useState(createQueryClient);

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <RouterProvider router={router} />
        </ThemeProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}
